import React, { useEffect, useState } from 'react';
import { useUserAccess } from '../hooks/useUserAccess';
import DeleteDocButton from '../components/DeleteDocButton';
import { IconBuilding, IconDoc, IconLock } from '../components/Icons';
import './PersonalDocs.css';

// Container corporativo docs-admcen (grupo ADMCEN: diretoria, gerentes de
// departamento e comerciais lotados em Compras). Layout flat, somente leitura.
function AdmcenDocs({ user }) {
  const { canUpload } = useUserAccess();
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    fetch('/api/listaDocumentos?container=docs-admcen')
      .then(res => res.json())
      .then(data => {
        if (data.error) {
          setError(data.error + (data.yourJobTitle ? ` (seu cargo: ${data.yourJobTitle})` : ''));
        } else {
          setFiles(data.files || []);
        }
      })
      .catch(err => setError('Erro ao carregar documentos'))
      .finally(() => setLoading(false));
  }, []);

  const formatFileSize = (bytes) => {
    if (!bytes) return '—';
    const kb = bytes / 1024;
    if (kb < 1024) return `${kb.toFixed(1)} KB`;
    return `${(kb / 1024).toFixed(1)} MB`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    return new Date(dateStr).toLocaleDateString('pt-BR', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="personal-container">
        <p className="loading-text">Carregando documentos...</p>
      </div>
    );
  }

  return (
    <div className="personal-container">
      <div className="personal-header">
        <h2><span className="page-icon"><IconBuilding /></span>Documentos ADMCEN</h2>
        <p>Acesso corporativo (diretoria, departamentos e compras)</p>
      </div>

      {error && (
        <div className="access-denied-card">
          <span className="access-icon"><IconLock /></span>
          <h3>Acesso negado</h3>
          <p>{error}</p>
        </div>
      )}

      {!selectedFile && !error && (
        <div className="files-list">
          {files.length === 0 && (
            <p className="empty-message">Nenhum documento disponível.</p>
          )}

          {files.map((file, index) => (
            <div key={index} className="file-card" onClick={() => setSelectedFile(file)}>
              <div className="file-icon"><IconDoc /></div>
              <div className="file-info">
                <span className="file-name">{file.name}</span>
                <span className="file-meta">
                  {formatFileSize(file.size)} • {formatDate(file.lastModified)}
                </span>
              </div>
              <button className="view-button">Visualizar</button>
              <DeleteDocButton
                canDelete={canUpload}
                container="docs-admcen"
                file={file.fullPath || file.name}
                onDeleted={() => setFiles(prev => prev.filter((_, i) => i !== index))}
              />
            </div>
          ))}
        </div>
      )}

      {selectedFile && (
        <div className="pdf-viewer-fullscreen">
          <div className="pdf-viewer-topbar">
            <button className="back-button" onClick={() => setSelectedFile(null)}>
              ← Voltar
            </button>
            <div className="pdf-viewer-info">
              <span className="pdf-title">{selectedFile.name}</span>
              <span className="pdf-subtitle">Documentos ADMCEN</span>
            </div>
          </div>

          <iframe
            className="pdf-viewer-frame"
            src={`/api/getDocument?container=docs-admcen&file=${encodeURIComponent(selectedFile.fullPath || selectedFile.name)}#toolbar=0&navpanes=0&scrollbar=0`}
            title={selectedFile.name}
          />
        </div>
      )}
    </div>
  );
}

export default AdmcenDocs;
